import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { clearChangePassword } from 'redux/users/actions';

import Button from 'components/elements/buttons/Button';
import ChangePasswordModal
  from 'components/dashboard/security-content/ChangePasswordModal';

import './ChangePassword.css';

function ChangePassword(props) {
  const { clearChangePassword, changePasswordSuccess } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="change-password__component">
      <div className="wrapper">
        <div className="text">{t("Password")}</div>
          <Button
            small
            onClick={() => setModalOpen(true) }
          >
            {t("Change")}
          </Button>
      </div>

      {/* Change Email Modal */}
      <ChangePasswordModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          if (changePasswordSuccess) {
            clearChangePassword();
          }
        }}
      />
    </div>
  );
}

ChangePassword.propTypes = {
  clearChangePassword: PropTypes.func.isRequired,
  changePasswordSuccess: PropTypes.object,
};

ChangePassword.defaultProps = {
  changePasswordSuccess: null,
};

const mapStateToProps = state => (
  {
    changePasswordSuccess: state.usersReducer.changePasswordSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    clearChangePassword,
  },
)(ChangePassword);
